module.exports = {
  methods: {
    displayError(string, timeout = false){
      this.$store.commit('baseAddNotification', {
        title: 'Error!',
        text:  string,
        type: 'error',
        timeout: timeout,
      })
    },
    displaySuccess(string, timeout = true){
      this.$store.commit('baseAddNotification', {
        title: 'Success!',
        text:  string,
        type: 'success',
        timeout: timeout,
      })
    },
  },
}